import { IBusiness } from '@/coreDomainsModule/entities/businessBase';

import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IBusinessRepository } from './interfaces/businessRepository';
import { getBusinessManager } from './organizationTable/businessManage';

/**
 * 取引情報の永続化の責務を負うクラス
 * モジュール化に伴い、新旧IBusinessが混在している(23/12時点)
 * 対応が完了するまで、一旦こちらで吸収する
 * @interface IBusinessRepository
 * @function save
 * @function balkSave
 * @function get
 * @function balkGet
 */
export class OrganizationBusinessRepository implements IBusinessRepository {
  /**
   * 取引情報を保存する
   * @param business - 取引情報 [IBusiness]
   */
  async save(business: IBusiness): Promise<INetworkResult<void, Error>> {
    try {
      await getBusinessManager().register(business); // getBusinessManagerがrepository
      return {
        status: {
          type: 'success',
          data: undefined,
        },
      };
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('保存に失敗しました'),
        },
      };
    }
  }

  /**
   * 取引情報を一括保存する
   * @param businesses - 取引情報[IBusiness[]]
   */
  async balkSave(businesses: IBusiness[]): Promise<INetworkResult<void, Error>> {
    try {
      await getBusinessManager().bulkRegister(businesses);
      return {
        status: {
          type: 'success',
          data: undefined,
        },
      };
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('保存に失敗しました'),
        },
      };
    }
  }

  /**
   * businessIdにマッチする取引を取得する
   * @param businessId - 取引ID
   */
  async get(businessId: string): Promise<INetworkResult<IBusiness, Error>> {
    try {
      const businesses: IBusiness[] = await getBusinessManager().getById([businessId]); // newGetBusinessManagerがrepository
      const business = businesses[0] ?? {};
      return {
        status: {
          type: 'success',
          data: business,
        },
      };
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('取得に失敗しました'),
        },
      };
    }
  }

  /**
   * businessIdsにマッチする取引を一括取得する
   * @param businessIds - 取引IDの配列
   */
  async balkGet(businessIds: string[]): Promise<INetworkResult<IBusiness[], Error>> {
    try {
      const businesses: IBusiness[] = await getBusinessManager().getById(businessIds); // newGetBusinessManagerがrepository
      return {
        status: {
          type: 'success',
          data: businesses,
        },
      };
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('取得に失敗しました'),
        },
      };
    }
  }

  /**
   * 全ての取引情報を取得する
   */
  async allGet(): Promise<INetworkResult<IBusiness[], Error>> {
    try {
      const businesses: IBusiness[] = await getBusinessManager().getAll(); // newGetBusinessManagerがrepository
      return {
        status: {
          type: 'success',
          data: businesses,
        },
      };
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('取得に失敗しました'),
        },
      };
    }
  }
}
